<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">活动折扣券列表</div>

      <div class="count-list">
        <div class="list-item">
          <div class="item-num"><span>{{ countList.couponIssuedCount || 0 }}</span> 张</div>
          <div class="item-text">累计获取折扣券张数</div>
        </div>
        <div class="list-item">
          <div class="item-num"><span>{{ countList.couponRedeemedCount || 0 }}</span> 张</div>
          <div class="item-text">累计消耗折扣券张数</div>
        </div>
        <div class="list-item">
          <div class="item-num"><span>{{ countList.couponCount || 0 }}</span> 张</div>
          <div class="item-text">累计剩余折扣券张数</div>
        </div>
      </div>

      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button
          class="common-bg-button"
          @click="toEditOrder()"
        >
          查看关联用户表
        </button>
        <button
          class="common-bg-button"
          @click="() => { showMultiQuery = !showMultiQuery }"
        >
          高级筛选
        </button>
        <button
          class="common-bg-button"
          @click="toExportList()"
        >
          导 出
        </button>
      </div>
      <!-- 高级筛选 -->
      <div
        class="multi-query-div el-fade-in-linear"
        v-if="showMultiQuery"
      >
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input
                clearable
                v-model="queryInfo.searchKey"
                size="small"
                placeholder="请输入用户手机号/用户姓名"
              ></el-input>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">折扣券类型</p>
              <el-select
                v-model="queryInfo.couponTypeCode"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择订单状态"
              >
                <el-option
                  v-for="a in orderStatusList"
                  :key="a.code"
                  :label="a.title"
                  :value="a.code"
                >
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">创建时间</p>
              <div class="flex-r">
                <el-date-picker
                    v-model="queryInfo.createFromTime"
                    type="datetime"
                    size="small"
                    prefix-icon="el-icon-date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                    class="flex-1"
                >
                </el-date-picker>
                <span class="time-query-line" style="line-height: 32px"> - </span>
                <el-date-picker
                    v-model="queryInfo.createToTime"
                    type="datetime"
                    size="small"
                    prefix-icon="el-icon-date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                    class="flex-1"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="query-flex-btns-div margin-bottom-16">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button
            class="common-bg-button"
            @click="resetQuery()"
          >
            重 置
          </button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" style="width: 100%" border stripe>
          <el-table-column type="index" width="40" align="center" />
          <el-table-column prop="userName" label="用户姓名" align="center" />
          <el-table-column prop="userMobile" label="用户手机号" align="center">
            <div
                slot="header"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <span style="margin-right: 8px">用户手机号</span>
              <img
                  style="cursor: pointer;width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_隐藏.png"
                  alt=""
                  v-if="!isFlag"
                  @click="flagChange('1')"
              />
              <img
                  style="cursor: pointer;width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_显示.png"
                  alt=""
                  v-if="isFlag"
                  @click="flagChange('1')"
              />
            </div>
            <template slot-scope="scope">
              <span v-if="isFlag">{{ scope.row.userMobile }}</span>
              <span v-else>{{
                  scope.row.userMobile
                      ? scope.row.userMobile.replace(
                          scope.row.userMobile.substring(2, 9),
                          "*******"
                      )
                      : ""
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="couponTypeCode" label="是否有关联用户" width="160" align="center">
            <template slot-scope="scope">
              <el-link type="primary" @click="goDetail(scope.row)"
                       v-if="scope.row.couponTypeCode === 'NEW_SIGN_COUPON' || scope.row.couponTypeCode === 'NEW_ACTIVATED_COUPON'">
                查看详情
              </el-link>
              <span v-else>{{'-'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="couponNo" label="折扣券 ID" align="center" />
          <el-table-column prop="couponTypeName" label="折扣券类型" align="center" />
          <el-table-column prop="couponCount" label="发放张数" align="center" />
          <el-table-column prop="validityPeriod" label="折扣券有效周期" align="center" />
          <el-table-column prop="createdWhen" label="创建时间" align="center" />
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
      </div>
    </div>

    <!-- 关联用户信息 -->
    <el-dialog title="关联用户信息" width="50%" :visible.sync="contactUserValidDialog">
      <div style="display: flex; align-items: center;">
        <el-table :data="contactData" style="width: 100%" border stripe>
          <el-table-column type="index" width="45" align="center" />
          <el-table-column prop="shareUserMobile" label="用户手机号" align="center">
            <div
                slot="header"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <span style="margin-right: 8px">用户手机号</span>
              <img
                  style="cursor: pointer;width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_隐藏.png"
                  alt=""
                  v-if="!isPopFlag"
                  @click="flagChange('2')"
              />
              <img
                  style="cursor: pointer;width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_显示.png"
                  alt=""
                  v-if="isPopFlag"
                  @click="flagChange('2')"
              />
            </div>
            <template slot-scope="scope">
              <span v-if="isPopFlag">{{ scope.row.shareUserMobile }}</span>
              <span v-else>{{
                  scope.row.shareUserMobile
                      ? scope.row.shareUserMobile.replace(
                          scope.row.shareUserMobile.substring(2, 9),
                          "*******"
                      )
                      : ""
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="relateUserName" label="关联用户姓名" align="center" />
          <el-table-column prop="relateUserMobile" label="关联用户手机号" align="center">
            <div
                slot="header"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <span style="margin-right: 8px">关联用户手机号</span>
              <img
                  style="cursor: pointer;width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_隐藏.png"
                  alt=""
                  v-if="!isPopSecondFlag"
                  @click="flagChange('3')"
              />
              <img
                  style="cursor: pointer;width: 20px; height: 20px"
                  src="../../../assets/app-card-style/眼睛_显示.png"
                  alt=""
                  v-if="isPopSecondFlag"
                  @click="flagChange('3')"
              />
            </div>
            <template slot-scope="scope">
              <span v-if="isPopSecondFlag">{{ scope.row.relateUserMobile }}</span>
              <span v-else>{{
                  scope.row.relateUserMobile
                      ? scope.row.relateUserMobile.replace(
                          scope.row.relateUserMobile.substring(2, 9),
                          "*******"
                      )
                      : ""
                }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="relateOperation" label="关联动作" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.relateOperation === 'SIGN'">报名成功</span>
              <span v-if="scope.row.relateOperation === 'ACTIVATED'">激活成功</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdWhen" label="创建时间" align="center" />
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      isFlag: false,
      pageConfig: pageConfig, // 页面配置
      countList: {},
      tableData: [], // 表格数据
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      showMultiQuery: false,
      orderStatusList: [
        { code: "NEW_SIGN_COUPON", title: "拉新报名折扣券" },
        { code: "NEW_ACTIVATED_COUPON", title: "拉新激活折扣券" },
        { code: "ACTIVATED_COUPON", title: "设备安装激活券" },
        { code: "CHARGE_COUPON", title: "充电度电折扣券" },
      ],

      contactUserValidDialog: false,
      contactData: [],
      isPopFlag: false,
      isPopSecondFlag: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init () {
      let _ = this;
      _.getListData(this.pagination, true);
      _.getCount();

    },
    getCount() {
      let _ = this;
      _.$H.post(_, _.$A.zeropay.couponListCount, {}).then(res => {
        _.countList = res.data.data || {};
      })
    },

    // 手机号码 - 显示隐藏
    flagChange(type) {
      let _ = this;
      if (type === '1') _.isFlag = !_.isFlag;
      if (type === '2') _.isPopFlag = !_.isPopFlag;
      if (type === '3') _.isPopSecondFlag = !_.isPopSecondFlag;
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.zeropay.couponList, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 活动订单编辑
    toEditOrder() {
      let _ = this;

      // _.$router.push({
      //   name: "activityDiscountListDetail",
      // });

      window.open(this.$router.resolve({ name: 'activityDiscountListDetail' }).href, '_blank')
    },
    goDetail(row) {
      let _ = this;
      _.$H.post(_, _.$A.zeropay.userRelationDetail, {couponNo: row.couponNo}).then((res) => {
        _.contactData = res.data.data || [];
        _.contactUserValidDialog = true;
      })
    },
    // 导出
    toExportList() {
      let _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6777";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.zeropay.couponListExcel, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        // var downUrl = "http://192.168.8.174:7997" + res.data.data.filePath;
        var downUrl = urls + res.data.data.filePath;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },
    resetQuery() {
      this.queryInfo = {};
      this.getListData(this.pagination, true);
    },
  },
};
</script>

<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}
.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
}
.count-list {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 24px;
  margin-top: 24px;

  .list-item {
    width: calc((100% / 3) - 100px);
    border: 1px solid #999;
    border-radius: 8px;
    padding: 16px 0;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;

    .item-num {
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-bottom: 16px;

      span{
        font-size: 32px;
        color: #333;
        margin-right: 16px;
      }
    }

    .item-text {
      font-size: 14px;
      color: #999;
      text-align: center;
    }

  }


}

</style>
